const rxpPlusIconBox = document.getElementById("rxp-plus-icon-box");
const rxpFileInput = document.getElementById("rxp-file-input");
const rxpUploadBox = document.getElementById("rxp-upload-box");
const rxpUploadTitle = document.getElementById("rxp-upload-title");

let rxpImageCount = 0;

rxpPlusIconBox.addEventListener("click", (event) => {
  event.stopPropagation();
  rxpFileInput.click();
});

const uploadedUrls = []; // keep track of all uploaded URLs

rxpFileInput.addEventListener("change", async (event) => {
  const files = event.target.files;
  const errorEl = document.getElementById("rxp-error-msg");
  errorEl.textContent = "";

  const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
  const maxSize = 5 * 1024 * 1024;

  const newUrls = [];
  const uploadPromises = [];

  for (let file of files) {
    if (!allowedTypes.includes(file.type)) {
      errorEl.textContent = "Please upload JPEG, PNG, or PDF only.";
      setTimeout(() => {
        errorEl.textContent = "";
      }, 5000); // Hide after 5 seconds
      continue;
    }

    if (file.size > maxSize) {
      errorEl.textContent = "File size should not exceed 5MB.";
      setTimeout(() => {
        errorEl.textContent = "";
      }, 5000); // Hide after 5 seconds
      continue;
    }

    // Wrap the entire preview + upload logic in a Promise
    const uploadPromise = new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        // Container for preview
        const container = document.createElement("div");
        container.className = "rxp-upload-preview";

        // Loader
        const loader = document.createElement("div");
        loader.className = "rxp-upload-loader";
        loader.innerHTML = `<div class="rxp-upload-spinner"></div>`;

        // Close button
        const closeBtn = document.createElement("div");
        closeBtn.innerHTML = "&times;";
        closeBtn.className = "rxp-upload-close";
        closeBtn.onclick = () => {
          rxpUploadBox.removeChild(container);

          const urlIndex = uploadedUrls.indexOf(container.uploadedUrl);
          if (urlIndex > -1) {
            uploadedUrls.splice(urlIndex, 1);
            updateCartAttributes(uploadedUrls);
          }

          updateRxpTitle();
        };

        container.appendChild(loader);
        container.appendChild(closeBtn);
        rxpUploadBox.insertBefore(container, rxpPlusIconBox);

        if (file.type === "application/pdf") {
          const canvas = document.createElement("canvas");
          canvas.className = "rxp-upload-canvas";
          container.appendChild(canvas);

          const loadingTask = pdfjsLib.getDocument(e.target.result);
          loadingTask.promise
            .then((pdf) => {
              pdf.getPage(1).then((page) => {
                const viewport = page.getViewport({ scale: 1.5 });
                const context = canvas.getContext("2d");
                canvas.width = viewport.width;
                canvas.height = viewport.height;

                page
                  .render({
                    canvasContext: context,
                    viewport: viewport,
                  })
                  .promise.then(() => {
                    loader.remove();
                    canvas.className = "rxp-upload-canvas";
                  });
              });
            })
            .catch((err) => {
              console.error("Error loading PDF:", err);
            });
        } else {
          const img = document.createElement("img");
          img.src = e.target.result;
          img.className = "rxp-upload-img";
          container.appendChild(img);

          // Simulate loading delay (optional)
          setTimeout(() => {
            loader.remove();
          }, 100); // You can increase if needed
        }

        updateRxpTitle();

        uploadPrescription(file)
          .then((url) => {
            container.uploadedUrl = url;
            newUrls.push(url);
            resolve();
          })
          .catch((err) => {
            console.error("Upload failed:", err);
            rxpUploadBox.removeChild(container);
            rxpImageCount--;
            updateRxpTitle();
            reject(err);
          });
      };
      reader.readAsDataURL(file);
    });
    uploadPromises.push(uploadPromise);
  }

  rxpFileInput.value = "";

  // Wait for all uploads to finish, then update cart attribute once
  await Promise.all(uploadPromises);
  if (newUrls.length > 0) {
    // Fetch current cart URLs
    const cart = await fetch("/cart.js").then((res) => res.json());
    let existingUrls = [];
    if (cart.attributes && cart.attributes["Prescription Upload URL"]) {
      try {
        existingUrls = JSON.parse(cart.attributes["Prescription Upload URL"]);
        if (!Array.isArray(existingUrls)) existingUrls = [existingUrls];
      } catch (e) {
        existingUrls = [cart.attributes["Prescription Upload URL"]];
      }
    }
    // Merge and deduplicate
    const allUrls = [
      ...existingUrls,
      ...newUrls.filter((url) => !existingUrls.includes(url)),
    ];
    await updateCartAttributes(allUrls);
    // Also update the local uploadedUrls array
    uploadedUrls.length = 0;
    uploadedUrls.push(...allUrls);
  }
});

async function updateCartAttributes(urls) {
  try {
    const attributes =
      urls.length > 0
        ? { "Prescription Upload URL": JSON.stringify(urls) }
        : { "Prescription Upload URL": "" };

    const cartResponse = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes }),
    });

    if (!cartResponse.ok) {
      console.error("Cart update failed:", await cartResponse.text());
      throw new Error("Failed to update cart attributes");
    }
  } catch (error) {
    console.error("Error updating cart attributes:", error);
  }
}

function updateRxPreviewTitle() {
  const fileUploadBox = document.getElementById("rxp-upload-box");
  const uploadBtn = document.getElementById("rxp-upload-btn");
  const checkoutBtn = document.getElementById("rxp-checkout-btn");
  const uploadTitle = document.getElementById("rxp-upload-title");

  // Count elements with either class inside the container
  const previousImagesCount = fileUploadBox
    ? fileUploadBox.querySelectorAll(".rxp-upload-canvas, .rxp-upload-img")
        .length
    : 0;
  uploadTitle.textContent = `Uploaded Prescriptions (${previousImagesCount})`;

  if (previousImagesCount === 0) {
    uploadBtn.classList.add("show-rxp-upload-btn");
    uploadBtn.classList.remove("hide-rxp-upload-btn");
    checkoutBtn.classList.add("hide-rxp-checkout-btn");
    checkoutBtn.classList.remove("show-rxp-checkout-btn");
  } else {
    uploadBtn.classList.add("hide-rxp-upload-btn");
    uploadBtn.classList.remove("show-rxp-upload-btn");
    checkoutBtn.classList.add("show-rxp-checkout-btn");
    checkoutBtn.classList.remove("hide-rxp-checkout-btn");
  }
}

function updateRxpTitle() {
  const fileUploadBox = document.getElementById("rxp-upload-box");

  const previousImagesCount = fileUploadBox
    ? fileUploadBox.querySelectorAll(".rxp-upload-canvas, .rxp-upload-img")
        .length
    : 0;
  const totalCount = rxpImageCount + previousImagesCount;
  rxpUploadTitle.textContent = `Uploaded Prescriptions (${totalCount})`;
  const uploadBtn = document.getElementById("rxp-upload-btn");
  const checkoutBtn = document.getElementById("rxp-checkout-btn");

  if (totalCount === 0) {
    uploadBtn.classList.add("show-rxp-upload-btn");
    uploadBtn.classList.remove("hide-rxp-upload-btn");
    checkoutBtn.classList.add("hide-rxp-checkout-btn");
    checkoutBtn.classList.remove("show-rxp-checkout-btn");
  } else {
    uploadBtn.classList.add("hide-rxp-upload-btn");
    uploadBtn.classList.remove("show-rxp-upload-btn");
    checkoutBtn.classList.add("show-rxp-checkout-btn");
    checkoutBtn.classList.remove("hide-rxp-checkout-btn");
  }
}

document.getElementById("rxp-upload-btn").addEventListener("click", (event) => {
  event.stopPropagation();
  rxpFileInput.click();
});

window.removeScheduleEItemsList = function () {
  const button = document.getElementById("removeProceedBtn");
  if (!button) return;

  button.disabled = true;
  const originalText = button.innerText;
  button.innerText = "Processing...";

  if (
    !Array.isArray(window.scheduleEItemKeys) ||
    window.scheduleEItemKeys.length === 0
  ) {
    button.disabled = false;
    button.innerText = originalText;
    return;
  }

  const updates = {};
  window.scheduleEItemKeys.forEach((key) => {
    updates[key] = 0;
  });

  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      updates,
      attributes: {
        "Prescription Upload URL": null,
      },
    }),
  })
    .then((res) => res.json())
    .then((updatedCart) => {
      if (updatedCart) {
        fetch(
          window.location.pathname + "?sections=cart-drawer,header,main-cart"
        )
          .then((res) => res.json())
          .then((data) => {
            // Update main cart section (cart items)
            const mainCart = document.querySelector(
              ".shopify-section--main-cart"
            );
            if (mainCart && data["main-cart"]) {
              mainCart.outerHTML = data["main-cart"];
              setTimeout(window.reInitCartEvents, 50);
            }

            // Update the cart bubble with the current item count
            fetch("/cart.js")
              .then((res) => res.json())
              .then((cart) => {
                document
                  .querySelectorAll("cart-count.count-bubble")
                  .forEach((bubble) => {
                    if (cart.item_count > 0) {
                      bubble.textContent = cart.item_count;
                      bubble.style.display = "";
                    } else {
                      bubble.textContent = "";
                      bubble.style.display = "none";
                    }
                  });
              });

            if (typeof initiateLogin === "function") {
              initiateLogin();
            }
          });
      }
    })
    .catch((err) => {
      console.error("Error updating cart:", err);
    })
    .finally(() => {
      if (button) {
        button.disabled = false;
        button.innerText = originalText;
      }
    });
};

window.reInitCartEvents = function () {
  const removeBtn = document.getElementById("removeProceedBtn");
  if (removeBtn) {
    removeBtn.onclick = window.removeScheduleEItemsList;
  }
};

// On DOMContentLoaded and after every section replacement, call this:
document.addEventListener("DOMContentLoaded", () => {
  window.reInitCartEvents();
  if (window.location.pathname === "/cart") {
    renderRxPrescriptionPreviewsFromCart();
    const checkoutBtn = document.getElementById("rxp-checkout-btn");
    if (checkoutBtn && typeof initiateLogin === "function") {
      checkoutBtn.addEventListener("click", () => {
        initiateLogin();
      });
    }
  }
});

// --- Show Prescription Previews from Cart Attributes ---
function renderRxPrescriptionPreviewsFromCart() {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const attr =
        cart.attributes && cart.attributes["Prescription Upload URL"];
      if (attr) {
        let urls = [];
        try {
          urls = JSON.parse(attr);
          if (!Array.isArray(urls)) urls = [urls];
        } catch (e) {
          urls = [attr];
        }
        if (urls.length > 0) {
          showRxPrescriptionPreview(urls);
        }
      }
      updateRxPreviewTitle();
    });
}

// --- Show Prescription Preview ---
function showRxPrescriptionPreview(urls) {
  const uploadBox = document.getElementById("rxp-upload-box");
  if (!uploadBox) return;
  // Clear previous previews except the plus icon
  Array.from(uploadBox.children).forEach((child) => {
    if (!child.id || child.id !== "rxp-plus-icon-box") {
      child.remove();
    }
  });
  if (!urls || !Array.isArray(urls) || urls.length === 0) return;
  urls.forEach((url) => {
    const imgContainer = document.createElement("div");
    imgContainer.className = "rxp-upload-preview";
    // Add cross icon for removal
    const closeBtn = document.createElement("div");
    closeBtn.className = "rxp-upload-close";
    closeBtn.innerHTML = "&times;";
    closeBtn.title = "Remove";
    closeBtn.onclick = function () {
      imgContainer.remove();
      // Remove this URL from cart attributes
      updateRxPreviewTitle();
      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          let attr =
            cart.attributes && cart.attributes["Prescription Upload URL"];
          let urlsArr = [];
          if (attr) {
            try {
              urlsArr = JSON.parse(attr);
              if (!Array.isArray(urlsArr)) urlsArr = [urlsArr];
            } catch (e) {
              urlsArr = [attr];
            }
            // Remove the clicked URL
            const updatedUrls = urlsArr.filter((u) => u !== url);
            fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                attributes: {
                  "Prescription Upload URL":
                    updatedUrls.length > 0 ? JSON.stringify(updatedUrls) : null,
                },
              }),
            });
          }
        });
    };
    if (url.match(/\.(pdf)$/i)) {
      // PDF preview using PDF.js
      const canvas = document.createElement("canvas");
      canvas.className = "rxp-upload-canvas upload-preview-border";
      canvas.width = 80;
      canvas.height = 100;
      imgContainer.appendChild(canvas);
      imgContainer.appendChild(closeBtn);
      if (window.pdfjsLib) {
        pdfjsLib
          .getDocument(url)
          .promise.then((pdf) => {
            pdf.getPage(1).then((page) => {
              const viewport = page.getViewport({ scale: 0.25 });
              const context = canvas.getContext("2d");
              canvas.width = viewport.width;
              canvas.height = viewport.height;
              page.render({ canvasContext: context, viewport });
            });
          })
          .catch(() => {
            canvas.getContext("2d").fillText("PDF", 10, 50);
          });
      } else {
        canvas.getContext("2d").fillText("PDF", 10, 50);
      }
    } else {
      // Image preview
      const img = document.createElement("img");
      img.className = "rxp-upload-img upload-preview-border";
      img.src = url;
      img.alt = "Prescription Preview";
      imgContainer.appendChild(img);
      imgContainer.appendChild(closeBtn);
    }
    uploadBox.insertBefore(
      imgContainer,
      document.getElementById("rxp-plus-icon-box")
    );
  });
}
